const PREFIX = 'profile';

export const profileQueryKeys = {
  root: [PREFIX],

  offer: [PREFIX, 'offer'],
  permissions: [PREFIX, 'permissions'],
} as const;
